import { menuItemClasses } from '@mui/material/MenuItem';
import { Theme, alpha } from '@mui/material/styles';

export const navbarStyles = (theme: Theme, isDark: boolean) => ({
  container: {
    width: '1OOvw',
    mb: 2.5
  },
  walletAndToggle: { mr: 3 },
  header: {
    px: 3,
    height: 96,
    [theme.breakpoints.down('md')]: {
      px: 0,
      height: 80
    }
  },
  headerPaper: {
    height: 80,
    pl: 0,
    pr: 4,
    pt: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundImage: 'none',
    boxShadow: 'none',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('lg')]: {
      pl: 3
    }
  },
  headerPaperMobile: {
    height: 80,
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: isDark ? '#0B091F' : 'rgb(233, 240, 253)',
    backgroundImage: 'none',
    boxShadow: '0 0 70px rgb(0 0 0 / 20%)',
    borderRadius: '0px',
    position: 'fixed',
    [theme.breakpoints.down('md')]: {
      zIndex: 6
    }
  },
  headerPaperDesktop: {
    borderRadius: '0px',
    height: 80,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundImage: 'none',
    boxShadow: 'none',
    pt: 0.5
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      pl: 3
    }
  },
  logoMd: {
    pl: 7
  },
  gridItemLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  gridItemLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    pl: 4
  },
  gridItemRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    pr: 4
  },
  button: {
    border: `1px solid ${theme.palette.info.main}`,
    px: 2,
    py: 0,
    height: 38,
    color: theme.palette.info.main,
    fontVariationSettings: "'wght' 500",
    minWidth: '100%',
    fontSize: '16px',
    [theme.breakpoints.up('sm')]: {
      minWidth: 'none'
    }
  },
  toggle: {
    ml: 1,
    pl: 0.5,
    [theme.breakpoints.up('md')]: {
      mr: 0
    }
  },
  tokenImage: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    objectFit: 'cover',
    maxWidth: 'none'
  },
  amount: { fontVariationSettings: "'wght' 600", pl: 0.75, pr: 0.5 },
  unit: { fontVariationSettings: "'wght' 400" },
  ball: { borderRadius: '25px' },
  avatar: {
    width: 36,
    height: 36,
    [theme.breakpoints.down('lg')]: {
      width: 36,
      height: 36
    }
  },
  menuText: {
    fontVariationSettings: "'wght' 400",
    color: theme.palette.text.primary
  },
  listItemIcon: {
    minWidth: 0,
    '& svg': {
      width: 20,
      height: 20,
      [theme.breakpoints.down('md')]: {
        width: 20,
        height: 20
      }
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 0,
    pr: 0,
    pl: 1,
    mx: 1,
    py: 0,
    '&:hover': {
      backgroundImage: theme.palette.action.focus,
      borderRadius: 2.5,
      backgroundColor: isDark
        ? 'transparent'
        : alpha(theme.palette.primary.main, 0.24),
      '& p': { color: theme.palette.primary.main },
      '& .MuiListItemIcon-root': {
        color: theme.palette.primary.main,
        backgroundColor: 'none',
        '& svg': {
          fill: theme.palette.primary.main
        }
      }
    },
    [theme.breakpoints.up('sm')]: {
      pb: 1,
      py: 1
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 46
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 40
    }
  },
  menu: {
    py: 2,
    '&:hover': {
      backgroundColor: 'none'
    },
    [theme.breakpoints.up('sm')]: {
      '& ul': { py: 1.5 }
    }
  },
  menuBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: 'none'
    }
  },
  paperProps: {
    width: 220,
    overflow: 'visible',
    mt: 1.5,
    borderRadius: '12px',
    backgroundColor: isDark ? '#1D1D21' : theme.palette.background.default,
    boxShadow: isDark
      ? '0px 8px 12px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.05)'
      : '0px 0px 0px 1px rgba(150, 150, 150, 0.035),0px 8px 28px rgba(22, 22, 26, 0.08)',
    backdropFilter: isDark ? 'blur(16px)' : 'blur(60px)',
    color: 'secondary',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0
    },
    [` & .${menuItemClasses.gutters}:hover`]: {
      color: theme.palette.primary.main,
      backgroundColor: 'none',
      '& p': {
        fontWeight: 600
      },
      '& svg': {
        fill: theme.palette.primary.main
      }
    }
  },
  containerBalanceOnRamper: {
    mt: 2.5
  },
  onRamperButton: { cursor: 'pointer' },
  walletIconButton: {
    '& svg': {
      width: 24,
      height: 24
    }
  }
});
